<template>
   <div class="shipin-info">
     <video v-if="videoitem.image" controls style="width: 100%;height:225px;display:block" class="video-js vjs-default-skin vjs-big-play-centered" >
        <source :src="videoitem.image" type="video/mp4" />
    </video>
    <div class="tupian-list">
        <div v-for="(item,index) in tupainArr" :key="index" class="item" @click="godetail(item)">
            <img :src="item.image">
            <div class="title">{{ item.title }}</div>
        </div>
    </div>
    
   </div>
</template>
<script>
import { mapState } from "vuex";
export default {
   name: '',
   components: {
     
   },
   computed: mapState([
    "userInfo",
   ]),
   mixins: [],
   props: {
     
   },
   data() {
     return {
        videoitem: {},
        tupainArr: []
     }
   },
   watch: {
     
   },
   mounted() {
     this.getData()
   },
   methods: {
    godetail(item){
        this.$router.push(`/detail?id=${item.id}`)
    },
    getData(){
        this.$http.get('/api/news/information', {
            limit: 4,
            type: 12,
        }).then(res => {
            if(res&&res.length>0){
                this.videoitem = res[0]
            }
        })

        this.$http.get('/api/news/information', {
            limit: 4,
            type: 13,
        }).then(res => {
            this.tupainArr = res;
        })
    },
   }
};
</script>
<style lang='scss' scoped>
.shipin-info{
    color: #fff;
    width: 450px;
    height: 485px;
    background: #fff;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 0px 20px;
    padding-top: 20px;
}
.tupian-list{
    display: flex;
    flex-wrap: wrap;
    .item{
        margin-right: 0px;
        width: calc(50% - 10px);
        height: 95px;
        margin-top: 16px;
        cursor: pointer;
        img{
            width: 100%;
            height: 80px;
        }
        .title{
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            word-break: break-all;
            color: #333333;
            font-size: 13px;
        }
    }
    .item:nth-child(2n+1){
        margin-right: 20px;
    }
}

</style>